<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="forms w-100 d-block col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="propertyFeatureTemplates" formControlName="propertyFeatureTemplateId"
            optionLabel="templateName" optionValue="propertyFeatureTemplateId" [filter]="true"
            filterBy="templateName" [showClear]="false" appendTo="body"
            placeholder="Select Property Feature Template">
          </p-dropdown>
          <label for="Select Property Feature Template">Select Property Feature Template</label>
          @for (validation of validationMessages.propertyFeatureTemplateId; track validation) {
            <span>
              @if (form1.get('propertyFeatureTemplateId').hasError(validation.type) && (form1.get('propertyFeatureTemplateId').dirty || form1.get('propertyFeatureTemplateId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              <!-- <button pButton *ngIf="employeeAcqPaymentId" class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button> -->
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

            @if (!propertyFeatureId) {
              <button pButton class="btn-addt p-button" (click)="addToTemplate()">Submit</button>
            }
          </div>
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

          @if (!propertyFeatureId) {
            <button pButton class="btn-addt p-button" (click)="addToTemplate()">Submit</button>
          }
        </div>
      </div>
    </div>
  </div>